/* Cohen Dubois — flèches de navigation sur la galerie produit (ordinateur) */
(function () {
  var FLECHE = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function vignettes(racine) {
    return Array.prototype.slice.call(
      racine.querySelectorAll('.thumbnail-list__item:not([hidden]) .thumbnail')
    );
  }

  function poser(media) {
    if (media.querySelector('.cd-gal')) return;
    var racine = media.closest('.product__media-wrapper') || media.closest('.product');
    if (!racine) return;
    if (vignettes(racine).length < 2) return;

    var scene = media.querySelector('.product__media-list') || media;
    if (getComputedStyle(scene).position === 'static') scene.style.position = 'relative';

    var hab = document.createElement('div');
    hab.className = 'cd-gal';
    hab.innerHTML =
      '<button type="button" class="cd-gal-prev" aria-label="Previous image">' + FLECHE + '</button>' +
      '<button type="button" class="cd-gal-next" aria-label="Next image" style="transform:translateY(-50%) rotate(180deg)">' + FLECHE + '</button>';
    scene.appendChild(hab);

    hab.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var v = vignettes(racine);
      if (!v.length) return;
      var i = v.findIndex(function (x) { return x.getAttribute('aria-current') === 'true'; });
      if (i < 0) i = 0;
      var j = b.classList.contains('cd-gal-next') ? (i + 1) % v.length : (i - 1 + v.length) % v.length;
      v[j].click();
    });
  }

  function balayer() {
    document.querySelectorAll('media-gallery').forEach(poser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', balayer);
  } else {
    balayer();
  }
  document.addEventListener('shopify:section:load', balayer);
})();

/* ------------------------------------------------------------------ */
/* Cohen Dubois — cadeaux automatiques                                 */
/* Chaque cadeau : une variante, un seuil (centimes, sous-total AVANT  */
/* remise, cadeaux exclus) et une periode facultative (ISO UTC).       */
/* Ajoute le cadeau quand il est du, le retire sinon. La gratuite est  */
/* garantie cote serveur (prix 0 ou remise automatique sur la periode) */
/* ------------------------------------------------------------------ */
window.CD_CADEAUX = window.CD_CADEAUX || [
  /* etui Cognac & Oak offert des 350 $ (prix 0) */
  { variante: 58583113859455, seuil: 35000 },
  /* Black November : Pocket Watch Pouch offerte des le 1er article (remise auto -100 %) */
  { variante: 58583114088831, seuil: 1, debut: '2026-11-01T04:00:00Z', fin: '2026-11-27T04:59:59Z' },
  /* Black Friday 27 -> 29/11 (heure NY) : pochette pour tous, Time Traveler des 500 $ (remises auto -100 %) */
  { variante: 58583114088831, seuil: 1, debut: '2026-11-27T05:00:00Z', fin: '2026-11-30T04:59:59Z' },
  /* Cognac des 200 $ du 26/11 23 h 50 (Paris) au 07/12 minuit (NY) : Black Friday + Cyber Week, comme la barre du panier */
  { variante: 58583113859455, seuil: 20000, debut: '2026-11-26T22:50:00Z', fin: '2026-12-08T04:59:59Z' },
  { variante: 58583113630079, seuil: 50000, debut: '2026-11-26T22:50:00Z', fin: '2026-11-30T04:59:59Z' },
  /* Noel 08 -> 25/12 (heure NY) : pochette offerte des le 1er article (remise auto -100 %) */
  { variante: 58583114088831, seuil: 1, debut: '2026-12-08T05:00:00Z', fin: '2026-12-26T04:59:59Z' }
];
/* compatibilite : CD_CADEAU = premier cadeau (lu ailleurs pour la barre du panier) */
window.CD_CADEAU = window.CD_CADEAU || window.CD_CADEAUX[0];

(function () {
  var LISTE = window.CD_CADEAUX;
  var enCours = false;

  function cents(x) { return typeof x === 'number' ? x : 0; }
  function estCadeau(id) { return LISTE.some(function (c) { return c.variante === id; }); }
  function actif(c) {
    var t = Date.now();
    return (!c.debut || t >= Date.parse(c.debut)) && (!c.fin || t <= Date.parse(c.fin));
  }

  /* sous-total hors cadeaux, pris AVANT toute remise */
  function totalEligible(panier) {
    return (panier.items || []).reduce(function (t, l) {
      if (estCadeau(l.variant_id)) return t;
      return t + cents(l.original_line_price != null ? l.original_line_price : l.line_price);
    }, 0);
  }

  function post(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corps)
    });
  }

  function rafraichir() {
    if (document.body.classList.contains('template-cart') || location.pathname.indexOf('/cart') === 0) {
      location.reload();
      return Promise.resolve();
    }
    return rafraichirTiroir().then(function () {
      document.dispatchEvent(new CustomEvent('cd:cadeau-maj'));
    });
  }

  /* redessine le tiroir et la pastille du panier apres l'ajout ou le retrait d'un cadeau (comme le FR) */
  function rafraichirTiroir() {
    var tiroir = document.querySelector('cart-drawer');
    /* pas d'en-tete Accept JSON : sur une page produit, Shopify renverrait la fiche produit au lieu des sections */
    return fetchOrigine(location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var lire = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
        var doc = lire(sections['cart-drawer']);
        var neuf = doc.querySelector('#CartDrawer');
        var actuel = document.querySelector('#CartDrawer');
        if (tiroir && neuf && actuel) {
          actuel.innerHTML = neuf.innerHTML;
          var neufTiroir = doc.querySelector('cart-drawer');
          tiroir.classList.toggle('is-empty', !!(neufTiroir && neufTiroir.classList.contains('is-empty')));
          var voile = tiroir.querySelector('#CartDrawer-Overlay');
          if (voile && tiroir.close) voile.addEventListener('click', tiroir.close.bind(tiroir));
        }
        var bulle = document.getElementById('cart-icon-bubble');
        var bulleNeuve = lire(sections['cart-icon-bubble']).querySelector('.shopify-section');
        if (bulle && bulleNeuve) bulle.innerHTML = bulleNeuve.innerHTML;
      })
      .catch(function () {});
  }

  /* une seule action par passage ; le fetch intercepte relance verifier() ensuite */
  function action(panier) {
    var total = totalEligible(panier);
    var vus = {};
    for (var i = 0; i < LISTE.length; i++) {
      var c = LISTE[i];
      /* une variante peut avoir plusieurs regles (periodes, seuils) : elle est due si l'une d'elles l'est */
      if (vus[c.variante]) continue;
      vus[c.variante] = true;
      var lignes = (panier.items || []).filter(function (l) { return l.variant_id === c.variante; });
      var doitEtreLa = LISTE.some(function (r) { return r.variante === c.variante && actif(r) && total >= r.seuil; });
      if (doitEtreLa && lignes.length === 0) return ['/cart/add.js', { items: [{ id: c.variante, quantity: 1 }] }];
      if (!doitEtreLa && lignes.length > 0) return ['/cart/change.js', { id: lignes[0].key, quantity: 0 }];
      /* un seul exemplaire, jamais plus */
      if (doitEtreLa && lignes[0].quantity !== 1) return ['/cart/change.js', { id: lignes[0].key, quantity: 1 }];
    }
    return null;
  }

  function verifier() {
    if (enCours) return Promise.resolve();
    enCours = true;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var a = action(panier);
        if (a) return post(a[0], a[1]).then(rafraichir).then(function () { return 'encore'; });
      })
      .catch(function () {})
      .then(function (suite) {
        enCours = false;
        /* plusieurs cadeaux peuvent changer d'un coup : on repasse jusqu'a ce que le panier soit stable */
        if (suite === 'encore') return verifier();
      });
  }

  /* au chargement */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verifier);
  } else {
    verifier();
  }

  /* apres chaque appel du theme a l'API panier */
  var fetchOrigine = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var chemin = typeof url === 'string' ? url : (url && url.url) || '';
    var resultat = fetchOrigine.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(chemin)) {
      resultat.then(function () { window.setTimeout(verifier, 120); }).catch(function () {});
    }
    return resultat;
  };
})();
